/**
 * Astitva Living — Product Gallery Component
 * Handles vertical thumbnail clicks, active media switching, and zoom effects
 */

(function () {
  'use strict';

  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail-id]'));
      this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
      this.init();
    }

    init() {
      this.thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
          e.preventDefault();
          const mediaId = thumb.dataset.thumbnailId;
          this.setActiveMedia(mediaId);
        });
        
        // Accessibility support
        thumb.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.setActiveMedia(thumb.dataset.thumbnailId);
          }
        });
      });
    }

    setActiveMedia(mediaId) {
      if (!mediaId) return;

      // Update thumbnails active state
      this.thumbnails.forEach((thumb) => {
        if (thumb.dataset.thumbnailId === mediaId.toString()) {
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.classList.remove('is-active');
          thumb.removeAttribute('aria-current');
        }
      });

      // Update main slides active state
      this.slides.forEach((slide) => {
        if (slide.dataset.mediaId === mediaId.toString()) {
          slide.classList.add('is-active');
          slide.setAttribute('aria-hidden', 'false');
          // Scroll or focus to active slide
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } else {
          slide.classList.remove('is-active');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
    }
  }

  customElements.define('product-gallery', ProductGallery);

})();
